import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { GisAuthGuard } from '@app/modules/gis/guards/gis-auth.guard';
import { GisAuthErrorComponent } from '@app/shared/components/gis-auth-error/gis-auth-error.component';
var ɵ0 = { key: 'geobrain-key' };
var routes = [
    { path: '', redirectTo: 'geobrain', pathMatch: 'full' },
    {
        path: 'map',
        canActivate: [MsalGuard, GisAuthGuard],
        loadChildren: '@gis/gis.module#GisModule'
    },
    {
        path: 'geobrain', canActivate: [MsalGuard, GisAuthGuard],
        loadChildren: '@geobrain-loader/geobrain-loader.module#GeobrainLoaderModule',
        data: ɵ0
    },
    {
        path: 'landing', canActivate: [MsalGuard],
        loadChildren: '@landing/landing.module#LandingModule'
    },
    {
        path: 'showcase', canActivate: [MsalGuard],
        loadChildren: '@showcase/style-showcase.module#StyleShowcaseModule'
    },
    {
        path: 'workspaces', canActivate: [MsalGuard, GisAuthGuard],
        loadChildren: '@workspaces/workspaces.module#WorkspacesModule'
    },
    {
        path: 'profile', canActivate: [MsalGuard],
        loadChildren: '@profile/profile.module#ProfileModule'
    },
    {
        path: 'geosentiment',
        loadChildren: '@geosentiment/geosentiment.module#GeosentimentModule'
    },
    {
        path: 'gis-auth-error',
        component: GisAuthErrorComponent
    }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };
